import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_AdminDashboard_OutStandingAwardsDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetDashboardOutstandingAwards = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<Wealthlane_AwardService_Dtos_AdminDashboard_OutStandingAwardsDto> | undefined,
  unknown
> => {
  const dashboardOutstandingAwards = useQuery(['getDashboardOutstandingAwards'], async () => {
    return await handleRequest(DashboardService.getApiAwardApiAppDashboardOutstandingAwards());
  });

  return dashboardOutstandingAwards;
};

export default useGetDashboardOutstandingAwards;
